import React from "react";
import PropTypes from "prop-types";
import FanFilterSelect from "./FanFilterSelect";
import FilterErrorIcon from "./FilterErrorIcon";

import SegmentPicker from "../../../../shared/SegmentPicker";
import { formInputContainerStyle } from "./FanFilterGroupForm";

const SegmentMembershipForm = (props) => {
  const {
    team,
    fanFilter,
    updateFanFilter,
  } = props;

  const conditions = fanFilter.filter_param_options.condition || [];
  const condition = fanFilter.filter_params.condition || "";
  const segmentId = fanFilter.filter_params.segment_id || null;
  const segmentType = fanFilter.filter_param_options.segment_type;
  const segmentName = fanFilter.filter_param_options.segment_title || fanFilter.filter_param_options.segment_name || "";

  return (
    <>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Select a condition"
          placeholder="Select a condition"
          options={conditions.map((cond) => ({ value: cond, label: cond }))}
          value={condition || null}
          onChange={(value) => {
            updateFanFilter({
              filter_params: {
                condition: value,
              },
            });
          }}
        />
      </div>
      {condition && (
        <div style={formInputContainerStyle}>
          <SegmentPicker
            team={team}
            value={{ segmentId }}
            selectedType={segmentType}
            selectedLabel={segmentName}
            matchTriggerWidth
            invalid={!segmentName}
            onChange={({ segmentId: newSegmentId }) => {
              updateFanFilter({
                filter_params: {
                  ...fanFilter.filter_params,
                  segment_id: newSegmentId,
                },
              });
            }}
          />
        </div>
      )}

      <FilterErrorIcon errors={fanFilter.filter_validation_errors} />
    </>
  );
};

SegmentMembershipForm.propTypes = {
  team: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }).isRequired,
  fanFilter: PropTypes.shape({
    filter_params: PropTypes.object.isRequired,
    filter_param_options: PropTypes.object.isRequired,
    filter_validation_errors: PropTypes.array.isRequired,
  }).isRequired,
  updateFanFilter: PropTypes.func.isRequired,
};

export default SegmentMembershipForm;
